export default "__VITE_ASSET__DVNKN4bq__"